import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

type State = {
	selectedYear?: number
}

type Actions = {
	setSelectedYear: (year: number) => void
	resetStore: () => void
}

export const usePlantYearStore = create<State & Actions>()(
	immer(set => ({
		selectedYear: undefined,

		setSelectedYear: (year: number) => {
			set(state => {
				state.selectedYear = year
			})
		},

		resetStore: () => {
			set(state => {
				state.selectedYear = undefined
			})
		},
	})),
)
